import React, { useState,useRef  } from 'react';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import styles from "assets/jss/material-kit-react/views/loginPage.js";

import image from "assets/img/bg7.jpg";
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'
import {
  useParams
} from "react-router-dom";
const useStyles = makeStyles(styles);

export default function LoginPage(props) {
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  let { PhoneNumber } = useParams();
  const inputCode = useRef(null)
  setTimeout(function() {
    setCardAnimation("");
  }, 700);
  const classes = useStyles();
  const { ...rest } = props;
  var onEnterPress = (e) => {
    if(e.key === 'Enter') {
      e.preventDefault();
      VerifyCode();
    }
  }
  function Go() {
    swal("در حال انتقال", {
      allowEscapeKey: false,
      allowOutsideClick: false,
      buttons: false,
      allowOutsideClick: false
    })

    Axios.post(Config.api + "Product/Buy/Start", {
      productIds: ["5ffcde0ea50731301591cf3c"],
      redirectUrl: "Expositions/ZarinPal/Verify",
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')

        }
      }).then((result) => {
       // return swal("رویداد از 25 بهمن آغاز خواهد شد، لطفا در زمان مقرر مراجعه فرمایید.")
        window.location.href = "/Expositions/Main/";
      }).catch(err => {
        console.log(err)
        if (err && err.response && err.response.status && err.response.status === 401) {
          localStorage.removeItem('token');
          props.history.push("/SignIn");
        }
        else if (err && err.response && err.response.status && err.response.status === 422)
          swal("اطلاعات ارسالی نادرست است.");
        else if (err && err.response && err.response.status && err.response.status === 409) {
          swal("اطلاعات ارسالی نادرست است.");
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })

  }
  var VerifyCode = () => {
    var code=inputCode.current.value
    Axios.post(Config.api+"Authentication/Verify", {
      phoneNumber: PhoneNumber,
      code:code,
      deviceName:Date.now()
    },
      {
        headers: {
          apikey: Config.apikey
        }
      }).then(async (result) => {
        localStorage.setItem('token', result.data.data.token);
        localStorage.setItem('registered', result.data.data.me.registered);
        localStorage.setItem('level', result.data.data.me.level);

        if(result.data.data.me.registered){
          props.history.push("/Profile");
/*
          swal({
            title: "ورود موفق!",
            text: "نمایشگاه ایران ایتکس هم اکنون در حال برگزاری ست.",
            icon: "success",
            
            buttons: {
              expo: {
                text: "ورود  به نمایشگاه",
                value: 0,
                visible: true,
                className: "",
                closeModal: true
              },
              event: {
                text: "رویدادهای جانبی",
                value: 1,
                visible: true,
                className: "",
                closeModal: true,
              },
              profile: {
                text: "پروفایل",
                value: 2,
                visible: true,
                className: "",
                closeModal: true,
              }
            }
          }).then((e)=>{
            if(e==0){
              Go();
            }else if(e==1){
              props.history.push("/Expositions");
            }else{
                props.history.push("/Profile");
            }
          })*/
        }
        else
        props.history.push("/Complete");
      }).catch((err) => {
        if (err&&err.response&&err.response.status&&err.response.status == 422)
        swal("کد وارد شده نادرست است");
      else if (err&&err.response&&err.response.data&&err.response.data.message&&err.response.data.message.pr)
        swal(err&&err.response&&err.response.data&&err.response.data.message.pr);
      else swal("خطایی رخ داده است.")

      })
  }
  return (
    <div>
      <Header
        absolute
        color="transparent"
        rightLinks={<HeaderLinks />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center"
        }}
      >
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={4}>
              <Card className={classes[cardAnimaton]}>
                <form className={classes.form}>
                  <CardHeader color="primary" className={classes.cardHeader}>
                    <h5>اعتبار سنجی</h5>
                  </CardHeader>
                  <CardBody>
                    <CustomInput
                      labelText="کد دریافتی..."
                      id="MobileNumber"
                      onKeyPress={onEnterPress}
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "tel",
                        inputRef:inputCode,
                        endAdornment: (
                          <InputAdornment position="end">
                            <PhoneAndroidIcon className={classes.inputIconsColor} />
                          </InputAdornment>
                        )
                      }}
                    />
                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    <div className={classes.extra}>
                      <a className={classes.extraLink} href='/SendCode'>
                        ارسال مجدد
                      </a>
                    </div>
                    <Button onClick={VerifyCode} color="success">
                      <ArrowBackIosIcon />
                    </Button>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}
